import { get } from "lodash"
import { createSelector } from "reselect"
import { getDatesAdjusted as getDatesAdjustedHelper } from "helpers/dates"
import { getPeriod } from "modules/portfolio-root/selectors/portfolios"
import { getLatestDate } from "modules/portfolio-root/selectors/dates"
import { getStartDate, getEndDate, getSelectedDate as getPortfolioSelectedDate } from "selectors/dates"

export const getDatesAdjusted = createSelector(
  [getPeriod, getStartDate, getEndDate, getLatestDate],
  getDatesAdjustedHelper,
)

const getRiskDateRaw = (state) => get(state, "modules.analyzeFactors.riskDate")

export const getRiskDate = createSelector(
  [getRiskDateRaw, getPortfolioSelectedDate, getEndDate],
  (riskDate, portfolioSelectedDate, endDate) => {
    return riskDate?.selectedDate || portfolioSelectedDate || endDate
  },
)
